import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=e9893772"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports